// Barrios (tienda v5) — port de maquetas/tienda-v5-barrios.html a JSX.
// Página 9 de Fase 3. Ruta /barrios (+ dev alias). Acento TEAL. Página de contenido
// (data de zonas en src/data/barrios.js). CSS co-locado bajo .tv5-page-barrios.
//
// Reusa shared: TopNav(teal) / Breadcrumb / Footer / BottomNav / MiniBar.
// Elementos activos de la maqueta: hero + KPIs (12 barrios / 5 días / $0) + grupos por
// día (Lun-Jue teal, Martes gold, Mié-Vie green) con chips + info práctica (3 cards) +
// CTA "fuera de zona" por WhatsApp.
//
// ── MAPA LEAFLET: DESACTIVADO ────────────────────────────────────────────────
// En la maqueta el mapa quedó explícitamente apagado ("Nico prefirió sin mapa";
// sección con display:none + <script type="text/plain" data-disabled>). Nico
// reconfirmó SIN mapa (2026-07-22). No se porta el mapa; se dejan abajo los
// polígonos de zona definidos en su día como audit trail por si se reactiva.
// El proyecto ya carga Leaflet desde CDN (patrón loadLeaflet() en components/MapPin.jsx),
// así que reactivar no requiere dependencia npm — solo re-enganchar estos polígonos:
//
//   Tiles: CartoDB Dark Matter → https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png
//   Centro aprox: [-34.905, -56.13], zoom 12. Colores por zona (fill/stroke):
//     teal  #00A8B5 / #4DCCD8   ·   gold #C5A059 / #E5C687   ·   green #10B981 / #6EE7B7
//   Zonas (polígonos [lat,lng]):
//     Martes (gold) · Cordón/Palermo/P.Rodó/P.Batlle · label [-34.902,-56.175]:
//       [-34.888,-56.198][-34.888,-56.152][-34.902,-56.148][-34.917,-56.162][-34.920,-56.185][-34.905,-56.198]
//     Lunes y Jueves (teal) · Pocitos/Pta Carretas/V.Biarritz · label [-34.912,-56.150]:
//       [-34.898,-56.165][-34.898,-56.140][-34.912,-56.138][-34.918,-56.145][-34.925,-56.152][-34.928,-56.164][-34.917,-56.170]
//     Miércoles y Viernes (green) · Buceo/Malvín/Pta Gorda/Carrasco · label [-34.897,-56.090]:
//       [-34.892,-56.140][-34.890,-56.100][-34.888,-56.070][-34.887,-56.045][-34.895,-56.038][-34.900,-56.065][-34.897,-56.095][-34.905,-56.125][-34.905,-56.140]
//     Miércoles y Viernes (green) · Carrasco Norte · label [-34.865,-56.050]:
//       [-34.855,-56.070][-34.855,-56.032][-34.882,-56.032][-34.882,-56.070]
// ─────────────────────────────────────────────────────────────────────────────
import { TopNav, Breadcrumb, Footer, BottomNav, MiniBar } from '../../components/tienda-v5';
import { TV5_ROUTES, TV5_EXTERNAL } from '../../components/tienda-v5/routes';
import { GRUPOS_BARRIOS, BARRIOS_KPIS } from '../../data/barrios';

const INFO_CARDS = [
  {
    emoji: '🕐',
    h: 'Franja de 4 horas',
    p: 'Elegís mañana (10-14), tarde (14-18) o tarde-noche (18-21). Te avisamos por WhatsApp cuando salimos del edificio anterior.',
  },
  {
    emoji: '🚪',
    h: 'Si no estás',
    p: 'Si hay portero, se lo dejamos. Si no, te escribimos por WhatsApp para coordinar reentrega — la primera no tiene recargo.',
  },
  {
    emoji: '⚡',
    h: 'Antes del día',
    p: 'Si necesitás algo fuera del día de tu barrio, podés pedir envío express en la Tienda (24-48 hs). Tiene costo según distancia.',
  },
];

const WA_FUERA_ZONA = `${TV5_EXTERNAL.whatsapp}?text=${encodeURIComponent(
  'Hola! Me gustaría saber cuándo llegan a mi barrio. Vivo en ___'
)}`;

export default function Barrios() {
  return (
    <div className="tv5-page-barrios">
      <style>{BARRIOS_CSS}</style>

      <TopNav active="barrios" accent="teal" />
      <Breadcrumb backHref={TV5_ROUTES.home} backLabel="Home" current="Barrios" />

      <main>
        {/* HERO */}
        <section className="br-hero">
          <span className="br-eyebrow">🗺 Zona Limpack</span>
          <h1>12 barrios de Montevideo,<br />cada uno con su día.</h1>
          <p>Organizamos el reparto por zonas para bajar la huella de carbono. Cada barrio recibe uno o dos días fijos por semana. Envío sin costo si te suscribís. Si necesitás otro día, te lo llevamos igual con costo extra.</p>
        </section>

        {/* KPIS */}
        <div className="br-kpis">
          {BARRIOS_KPIS.map((k) => (
            <div className="br-kpi" key={k.label}>
              <div className="br-kpi-num">{k.num}</div>
              <div className="br-kpi-label">{k.label}</div>
            </div>
          ))}
        </div>

        {/* GRUPOS POR DÍA */}
        <section className="br-seccion">
          <h2>Encontrá tu barrio</h2>
          <p className="br-seccion-sub">Agrupados por día de entrega. Elegís tu franja de 4 hs cuando te suscribís.</p>

          {GRUPOS_BARRIOS.map((g) => (
            <div className={`br-grupo br-grupo--${g.color}`} key={g.id}>
              <div className="br-grupo-header">
                <div className="br-grupo-emoji">{g.emoji}</div>
                <div className="br-grupo-titulos">
                  <h3>{g.dia}</h3>
                  <p>{g.resumen}</p>
                </div>
                <div className="br-grupo-count">{g.barrios.length} barrios</div>
              </div>
              <div className="br-grupo-barrios">
                {g.barrios.map((b) => (
                  <div className="br-chip" key={b.nombre}>
                    <div className="br-chip-nombre">{b.nombre}</div>
                    <div className="br-chip-nota">{b.nota}</div>
                  </div>
                ))}
              </div>
            </div>
          ))}
        </section>

        {/* INFO PRÁCTICA */}
        <section className="br-seccion">
          <h2>Cómo funciona el reparto</h2>
          <div className="br-info-cards">
            {INFO_CARDS.map((c) => (
              <div className="br-info-card" key={c.h}>
                <span className="br-info-emoji">{c.emoji}</span>
                <h3>{c.h}</h3>
                <p>{c.p}</p>
              </div>
            ))}
          </div>
        </section>

        {/* FUERA DE ZONA */}
        <div className="br-fuera-zona">
          <div>
            <div className="br-fuera-titulo">🚧 ¿No estás en la lista?</div>
            <h3>Avisame cuando lleguen a mi barrio</h3>
            <p>Estamos sumando barrios a demanda. Cuantos más vecinos pidan una zona, más rápido llegamos. Dejanos tu WA y te avisamos apenas abrimos tu barrio.</p>
          </div>
          <a href={WA_FUERA_ZONA} target="_blank" rel="noopener noreferrer" className="br-fuera-btn">
            Avisame por WA →
          </a>
        </div>
      </main>

      <MiniBar checkoutHref={TV5_ROUTES.checkout} />
      <Footer accent="teal" />
      <BottomNav active="barrios" />
    </div>
  );
}

const BARRIOS_CSS = `
.tv5-page-barrios {
  --tv5b-navy:#1A3461; --tv5b-teal:#00A8B5; --tv5b-gold:#C5A059; --tv5b-green:#10B981;
  --tv5b-bg:#0A1424; --tv5b-card:rgba(255,255,255,0.04); --tv5b-border:rgba(255,255,255,0.08);
  --tv5b-text:#F8F6F1; --tv5b-muted:rgba(248,246,241,0.65); --tv5b-dim:rgba(248,246,241,0.45);
  --safe-bottom:env(safe-area-inset-bottom, 0px);
  background:var(--tv5b-bg); color:var(--tv5b-text); min-height:100vh; position:relative;
  overflow-x:clip; max-width:100%;
  font-family:'Inter',-apple-system,BlinkMacSystemFont,sans-serif;
  padding-bottom:calc(72px + var(--safe-bottom));
}
.tv5-page-barrios::before {
  content:''; position:fixed; inset:0; pointer-events:none; z-index:0;
  background:
    radial-gradient(circle at 20% 10%, rgba(0,168,181,0.12) 0%, transparent 40%),
    radial-gradient(circle at 80% 60%, rgba(16,185,129,0.06) 0%, transparent 40%);
}
.tv5-page-barrios main { position:relative; z-index:1; }
@media (min-width:900px){ .tv5-page-barrios { padding-bottom:0; } }

/* HERO */
.tv5-page-barrios .br-hero { padding:40px 20px 20px; text-align:center; max-width:900px; margin:0 auto; }
.tv5-page-barrios .br-eyebrow { display:inline-block; color:var(--tv5b-teal); font-size:11px; font-weight:800; letter-spacing:0.15em; text-transform:uppercase; padding:6px 14px; background:rgba(0,168,181,0.1); border:1px solid rgba(0,168,181,0.3); border-radius:999px; margin-bottom:14px; }
.tv5-page-barrios .br-hero h1 { font-size:clamp(28px, 6vw, 46px); font-weight:800; letter-spacing:-0.03em; line-height:1.05; margin-bottom:12px; background:linear-gradient(135deg, var(--tv5b-text) 0%, var(--tv5b-teal) 100%); -webkit-background-clip:text; -webkit-text-fill-color:transparent; background-clip:text; }
.tv5-page-barrios .br-hero p { color:var(--tv5b-muted); font-size:15px; max-width:560px; margin:0 auto 20px; line-height:1.6; }

/* KPIS */
.tv5-page-barrios .br-kpis { max-width:800px; margin:0 auto; padding:20px; display:grid; grid-template-columns:repeat(3, 1fr); gap:12px; text-align:center; }
.tv5-page-barrios .br-kpi { background:var(--tv5b-card); border:1px solid var(--tv5b-border); border-radius:14px; padding:18px 12px; }
.tv5-page-barrios .br-kpi-num { font-size:clamp(22px, 4vw, 32px); font-weight:900; color:var(--tv5b-teal); letter-spacing:-0.02em; margin-bottom:4px; }
.tv5-page-barrios .br-kpi-label { font-size:11px; color:var(--tv5b-muted); font-weight:600; }

/* SECCIÓN */
.tv5-page-barrios .br-seccion { padding:40px 20px; max-width:1000px; margin:0 auto; }
.tv5-page-barrios .br-seccion h2 { font-size:clamp(22px, 4vw, 32px); font-weight:800; letter-spacing:-0.02em; margin-bottom:8px; text-align:center; }
.tv5-page-barrios .br-seccion-sub { text-align:center; color:var(--tv5b-muted); font-size:14px; margin:0 auto 32px; max-width:500px; line-height:1.5; }

/* GRUPO DÍA */
.tv5-page-barrios .br-grupo { background:var(--tv5b-card); border:1px solid var(--tv5b-border); border-radius:18px; padding:24px 20px; margin-bottom:16px; position:relative; overflow:hidden; }
.tv5-page-barrios .br-grupo::before { content:''; position:absolute; top:0; left:0; right:0; height:3px; background:linear-gradient(90deg, var(--tv5b-teal) 0%, rgba(0,168,181,0.3) 100%); }
.tv5-page-barrios .br-grupo--gold::before { background:linear-gradient(90deg, var(--tv5b-gold) 0%, rgba(197,160,89,0.3) 100%); }
.tv5-page-barrios .br-grupo--green::before { background:linear-gradient(90deg, var(--tv5b-green) 0%, rgba(16,185,129,0.3) 100%); }
.tv5-page-barrios .br-grupo-header { display:flex; align-items:center; gap:12px; margin-bottom:6px; }
.tv5-page-barrios .br-grupo-emoji { width:44px; height:44px; border-radius:12px; background:rgba(0,168,181,0.12); border:1px solid rgba(0,168,181,0.3); display:flex; align-items:center; justify-content:center; font-size:22px; flex-shrink:0; }
.tv5-page-barrios .br-grupo--gold .br-grupo-emoji { background:rgba(197,160,89,0.12); border-color:rgba(197,160,89,0.3); }
.tv5-page-barrios .br-grupo--green .br-grupo-emoji { background:rgba(16,185,129,0.12); border-color:rgba(16,185,129,0.3); }
.tv5-page-barrios .br-grupo-titulos h3 { font-size:18px; font-weight:800; letter-spacing:-0.01em; }
.tv5-page-barrios .br-grupo-titulos p { font-size:12px; color:var(--tv5b-muted); }
.tv5-page-barrios .br-grupo-count { margin-left:auto; font-size:11px; font-weight:700; color:var(--tv5b-muted); padding:4px 10px; background:rgba(255,255,255,0.06); border-radius:999px; white-space:nowrap; flex-shrink:0; }
.tv5-page-barrios .br-grupo-barrios { display:grid; grid-template-columns:repeat(2, 1fr); gap:8px; margin-top:16px; }
@media (min-width:640px){ .tv5-page-barrios .br-grupo-barrios { grid-template-columns:repeat(3, 1fr); } }
@media (min-width:900px){ .tv5-page-barrios .br-grupo-barrios { grid-template-columns:repeat(4, 1fr); } }
.tv5-page-barrios .br-chip { background:rgba(0,0,0,0.2); border:1px solid var(--tv5b-border); border-radius:10px; padding:12px 14px; transition:background 0.2s, border-color 0.2s, transform 0.2s; }
@media (hover:hover){
  .tv5-page-barrios .br-grupo .br-chip:hover { background:rgba(0,168,181,0.08); border-color:rgba(0,168,181,0.3); transform:translateX(2px); }
  .tv5-page-barrios .br-grupo--gold .br-chip:hover { background:rgba(197,160,89,0.08); border-color:rgba(197,160,89,0.3); }
  .tv5-page-barrios .br-grupo--green .br-chip:hover { background:rgba(16,185,129,0.08); border-color:rgba(16,185,129,0.3); }
}
.tv5-page-barrios .br-chip-nombre { font-weight:700; font-size:13px; margin-bottom:2px; }
.tv5-page-barrios .br-chip-nota { font-size:10px; color:var(--tv5b-dim); }

/* INFO PRÁCTICA */
.tv5-page-barrios .br-info-cards { display:grid; gap:14px; margin-top:10px; }
@media (min-width:768px){ .tv5-page-barrios .br-info-cards { grid-template-columns:repeat(3, 1fr); } }
.tv5-page-barrios .br-info-card { background:var(--tv5b-card); border:1px solid var(--tv5b-border); border-radius:14px; padding:22px 20px; }
.tv5-page-barrios .br-info-emoji { font-size:28px; margin-bottom:10px; display:block; }
.tv5-page-barrios .br-info-card h3 { font-size:16px; font-weight:800; margin-bottom:6px; letter-spacing:-0.01em; }
.tv5-page-barrios .br-info-card p { color:var(--tv5b-muted); font-size:13px; line-height:1.5; }

/* FUERA DE ZONA */
.tv5-page-barrios .br-fuera-zona { background:linear-gradient(135deg, rgba(197,160,89,0.12) 0%, rgba(197,160,89,0.04) 100%); border:1px solid rgba(197,160,89,0.3); border-radius:18px; padding:28px 22px; display:grid; gap:18px; max-width:800px; margin:40px auto 0; }
@media (min-width:640px){ .tv5-page-barrios .br-fuera-zona { grid-template-columns:1fr auto; align-items:center; gap:24px; } }
.tv5-page-barrios .br-fuera-titulo { font-size:11px; font-weight:800; letter-spacing:0.12em; text-transform:uppercase; color:var(--tv5b-gold); margin-bottom:6px; }
.tv5-page-barrios .br-fuera-zona h3 { font-size:20px; font-weight:800; margin-bottom:6px; letter-spacing:-0.01em; }
.tv5-page-barrios .br-fuera-zona p { color:var(--tv5b-muted); font-size:13px; line-height:1.5; }
.tv5-page-barrios .br-fuera-btn { background:var(--tv5b-gold); color:var(--tv5b-navy); padding:12px 22px; border-radius:10px; font-weight:800; font-size:13px; text-decoration:none; white-space:nowrap; display:inline-flex; align-items:center; justify-content:center; gap:6px; min-height:44px; transition:transform 0.2s; }
@media (hover:hover){ .tv5-page-barrios .br-fuera-btn:hover { transform:translateX(3px); } }

/* Reduced motion */
@media (prefers-reduced-motion:reduce){
  .tv5-page-barrios .br-chip, .tv5-page-barrios .br-fuera-btn { transition:none; }
}
`;
